import { render, staticRenderFns } from "./Adminclinicas.vue?vue&type=template&id=90faa644&scoped=true"
import script from "./Adminclinicas.vue?vue&type=script&lang=js"
export * from "./Adminclinicas.vue?vue&type=script&lang=js"
import style0 from "./Adminclinicas.vue?vue&type=style&index=0&id=90faa644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90faa644",
  null
  
)

export default component.exports